import React from "react";
import { connect } from "react-redux";
import { tramitesCarga } from "../mis-tramites/misTramites.act";
import { ramos } from "../mis-tramites/secciones";
import gnpFormatos from "./gnp-formatos.css";
import { servicios } from './../properties';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		listado: state.tramites.listado
	};
};

const mapDispatch = (dispatch) => {
	return {
		cargaFormatos: () => {
			dispatch(tramitesCarga());
		}
	};
};

class GnpFormatos extends React.Component {

	state = {
		ramo : "Todos",
		subRamo: "",
		secciones : []
	}

	componentWillMount = () => {
		this.props.cargaFormatos();
	}
	
	changeRamo = (ev) => {
		let key = ev.target.options.selectedIndex;
		this.setState({ramo: ev.target.value, subRamo: "", secciones: ramos[key].secciones});
	}
	
	changeSubRamo = (ev) => {
		this.setState({subRamo: ev.target.value});
	}

	componentDidMount() {
		const _body = document.getElementById("container");
		const _chage = function () {
			const height = _body.offsetHeight + 50;
			window.parent.postMessage({ frameHeight: height }, servicios.corporativo); //NOSONAR
		};
		new ResizeObserver(_chage).observe(_body);
		new MutationObserver(_chage).observe(_body, { attributes: true, childList: true, characterData: true });
}

	render() {
		return (
			<div className="gnp-formatos container" id="container">
				<p className="text-center">En esta sección puedes llenar, descargar o imprimir los formatos que necesitas para realizar un trámite. <br /> Solo selecciona ramo y trámite.</p>
				<div className="formulario">
					<div className="row">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-right">
							Selecciona un ramo:
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-left">
							<select name="ramo" className="selectPadding browser-default" onChange={this.changeRamo.bind(this)}>
								{ ramos.map((item,i) => 
									<option value={item.titulo} key={i}>{item.titulo}</option>
								)}
							</select>
						</div>
					</div>
					<div className="row mt-20">
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-right">
							Selecciona un trámite:
						</div>
						<div className="col-xs-12 col-sm-6 col-md-6 col-lg-6 text-xs-center text-sm-center text-md-left">
							<select name="tramite" className="selectPadding browser-default" onChange={this.changeSubRamo.bind(this)} disabled={this.state.secciones.length == 0 ? true : false}>
								<option value="">Seleccione una opción</option>
								{ this.state.secciones.map((item,i) => 
									<option value={item.titulo} key={i}>{item.titulo}</option>
								)}
							</select>
						</div>
					</div>
				</div>
				<div className="row mt-20">
					<div className="col-xs-12 text-center">
						<p></p>
					</div>
					<div className="col-xs-12 text-center">
						<ul className="listado">
							<li><p>Resultado de la búsqueda</p></li>
							{ this.props.listado.map((item, i) => {
								if(this.state.ramo == "Todos" || this.state.ramo == item.ramo) {
									if(this.state.subRamo == "" || this.state.subRamo == item.seccion) {
										return (
											<li key={i}>
												
												<a href={item.url} target="_blank" download><img src="https://www.gnp.com.mx/images/site/ico_pdf.gif" /> {item.archivo}</a>
											</li>
										);
									}
								}
							})}
						</ul>
					</div>
				</div>
			</div>
		);
	}
}

export default connect(mapState, mapDispatch)(GnpFormatos);



// WEBPACK FOOTER //
// ./src/gnp-servicios-formatos/gnp-formatos.cmpt.js